import { useEffect, useState } from "react";
import { SearchableDropdown } from "../shared/SearchableDropdown";
import { upsertCommerceDimTableItem, getEvents, getVendorLocations, upsertCommerceFactRow } from "../services/dimension-service";
import { useGetToken } from "../hooks/custom-hooks";
import toast from "react-hot-toast";

export const AddFactRowModal = ({
  onClose
}) => {
  const accessToken = useGetToken();
  const [events, setEvents] = useState([]);
  const [vendorLocations, setVendorLocations] = useState([]);
  const [isAmountFocused, setIsAmountFocused] = useState(false);
  const [values, setValues] = useState({
    eventKey: "",
    vendorLocationKey: "",
    amount: "",
  });

  const formatDate = (dateInt) => {
    const value = String(dateInt);

    return `${value.slice(4, 6)}/${value.slice(6, 8)}/${value.slice(0, 4)}`;
  };

  useEffect(() => {
    if (!accessToken) {
      return;
    }

    const loadDropdowns = async () => {
      const [eventList, vendorLocationList] = await Promise.all([
        getEvents({}, accessToken),
        getVendorLocations({}, accessToken),
      ]);

      setEvents(eventList?.data || []);
      setVendorLocations(vendorLocationList?.data || []);
    };

    loadDropdowns();
  }, [accessToken]);

  const eventOptions = events.map((event) => ({
    key: event.eventKey,
    label: `${formatDate(event.eventDate)} (${event.opponent})`,
  }));

  const vendorLocationOptions = vendorLocations.map((location) => ({
    key: location.vendorLocationKey,
    label: `${location.vendorName} (${location.sectionGroup} - ${location.section})`,
  }));
    

  const handleChange = (key, value) => {
    setValues((prev) => ({
      ...prev,
      [key]: value,
    }));
  };



  const handleCreate = async () => {
    try {
      console.log("Creating fact:", {
        eventKey: values.eventKey,
        vendorLocationKey: values.vendorLocationKey,
        amount: Number(values.amount),
      });

      const response = await upsertCommerceFactRow(
        values.eventKey,
        values.vendorLocationKey,
        Number(values.amount),
        accessToken
      );

      if (response?.data) {
        toast.success("Fact row has been successfully added.");
        onClose();
      }
    } catch (error) {
      toast.error("Failed to add fact row.");
      console.error(error);
    }
  };

  const isValid =
    values.eventKey &&
    values.vendorLocationKey &&
    values.amount !== "" &&
    !Number.isNaN(Number(values.amount));
  const formatCurrency = (value) => {
    if (value === "" || value == null) return "";

    return Number(value).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  };
  return (
    <div className="dim-modal-overlay">
      <div className="dim-modal dim-modal-large">
        <button
          className="dim-modal-close"
          onClick={onClose}
        >
          x
        </button>

        <div className="dim-modal-header">
          <h2>Add Fact</h2>
          <p>Add an amount for an event and vendor location.</p>
        </div>

        <div className="dim-modal-content dim-modal-content--single">
          <div className="dim-modal-main">
            <section className="dim-modal-card">
              <div className="dim-field-grid">
                <SearchableDropdown
                  className="searchable-dropdown dark-dropdown"
                  id="eventKey"
                  label="Event"
                  value={values.eventKey}
                  dropdownValues={eventOptions}
                  defaultPhrase="Select an event"
                  multiple={false}
                  handleDropdownChange={(e) => {
                    const selectedValue =
                      e.target.selectedOption?.key ??
                      e.target.selectedOption?.value ??
                      e.target.value;
                    handleChange("eventKey", selectedValue);
                  }}
                />

                <SearchableDropdown
                  className="searchable-dropdown dark-dropdown"
                  id="vendorLocationKey"
                  label="Vendor Location"
                  value={values.vendorLocationKey}
                  dropdownValues={vendorLocationOptions}
                  defaultPhrase="Select a vendor location"
                  multiple={false}
                  handleDropdownChange={(e) => {
                    const selectedValue =
                      e.target.selectedOption?.key ??
                      e.target.selectedOption?.value ??
                      e.target.value;
                    handleChange("vendorLocationKey", selectedValue);
                  }}
                />

                <div className="dim-field">
                  <label
                    className="dim-section-label"
                    htmlFor="amount"
                  >
                    Amount
                  </label>

                  <input
                    id="amount"
                    className="dim-text-input"
                    type="text"
                    inputMode="decimal"
                    placeholder="$0.00"
                    value={
                      isAmountFocused
                        ? values.amount
                        : formatCurrency(values.amount)
                    }
                    onFocus={() => setIsAmountFocused(true)}
                    onBlur={() => setIsAmountFocused(false)}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9.]/g, "");
                      handleChange("amount", value);
                    }}
                  />
                </div>
              </div>
            </section>
          </div>
        </div>

        <div className="dim-modal-actions">
          <button
            className="dim-btn-secondary"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="dim-btn-primary"
            onClick={handleCreate}
            disabled={!isValid}
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
};
